import { Box, TableBody } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import TableCellActions from "../../../Components/TableCellActions";
import FormPageHeader from "../../../Components/UI/FormPageHeader";
import ListingLayout from "../../../Components/UI/ListingLayout";
import Pagination from "../../../Components/UI/Pagination";
import TableLoader from "../../../Components/UI/TableLoader";
import {
  StyledTable,
  StyledTableCell,
  StyledTableHead,
  StyledTableRow,
} from "../../../Components/UI/Tables/Table";
import { fetchPages } from "../../../Stores/Pages/actions";
import { commonStyle } from "../../../commonStyle";
import { useStyles } from "../style";

const Pages = () => {
  const classes = useStyles();
  const history = useHistory();
  const commonClasses = commonStyle();
  const dispatch = useDispatch();
  const { id } = useParams();

  const { isFetchingPages, Pages, isDeleting } = useSelector(
    (state) => state.PagesReducer
  );

  const [list, setList] = useState({ data: { data: [] } });
  const [title, settitle] = useState("");

  let loading = isFetchingPages || isDeleting;

  useEffect(() => {
    dispatch(fetchPages({ page: 1, limit: 10, website_id: id }));
    settitle("");
  }, []);

  useEffect(() => {
    if (Pages?.count > 0) {
      setList(Pages?.data);
      let { data } = Pages;
      let page = data?.data?.[0];
      if (page?.website?.title) {
        settitle(page?.website?.title ?? "");
      }
    } else {
      setList({ data: { data: [] } });
      settitle(Pages?.title ?? "");
    }
  }, [Pages]);

  return (
    <>
      <ListingLayout
        title="Pages"
        redirect="/d/residence/add"
        item="ENQUIRIES"
        hideAdd={true}
      >
        <FormPageHeader
          title={`${title} Pages`}
          mode={"Manage"}
          pageName={"Pages"}
        />
        <Box className={classes.tableContainer}>
          <StyledTable>
            <StyledTableHead>
              <StyledTableRow>
                <StyledTableCell>Page Title</StyledTableCell>
                <StyledTableCell>Page URL</StyledTableCell>
                <StyledTableCell>Created At</StyledTableCell>
                <StyledTableCell>Actions</StyledTableCell>
              </StyledTableRow>
            </StyledTableHead>
            <TableBody>
              {loading ? (
                <TableLoader numOfColumns={5} />
              ) : (
                <>
                  {list?.data?.length > 0 ? (
                    list?.data?.map((row) => (
                      <StyledTableRow>
                        <StyledTableCell>
                          <p className={commonClasses.tableLabel}>
                            {row.page_title ?? `~`}
                          </p>
                        </StyledTableCell>
                        <StyledTableCell>
                          <p className={commonClasses.tableLabel}>
                            {row.page_url ?? `~`}
                          </p>
                        </StyledTableCell>
                        <StyledTableCell>
                          <p className={commonClasses.tableLabel}>
                            {row.created_at ?? `~`}
                          </p>
                        </StyledTableCell>
                        <StyledTableCell>
                          <TableCellActions
                            canEdit={true}
                            canDelete={false}
                            editMethod={() => {
                              history.push(`/d/website/${id}/pages/${row?.id}`);
                            }}
                          />
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell
                        colSpan={5}
                        style={{ textAlign: "center" }}
                      >
                        <i>No Data Found!</i>
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </>
              )}
            </TableBody>
          </StyledTable>
          <Pagination
            isLoading={loading}
            count={list?.data?.last_page ?? 1}
            page={list?.data?.current_page ?? 1}
            onPager={(page) => {
              dispatch(fetchPages({ page, limit: 10, website_id: id }));
            }}
          />
        </Box>
      </ListingLayout>
    </>
  );
};

export default Pages;
